import React from "react"
import styles from "./styles.scss"

class Quote extends React.Component {
  render() {
    const { image, author, children, authorPosition } = this.props

    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.quote}>”{children}”</div>
          <div className={styles.authorContainer}>
            <img
              src={image}
              alt={`Citatets källa, ${author}, ${authorPosition}`}
              className={styles.image}
            />
            <div className={styles.name}>
              - {`${author}, ${authorPosition}`}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Quote



// WEBPACK FOOTER //
// ./src/components/CaseStudy/CompanyInformation/Quote/index.jsx